export default "__VITE_ASSET__c8268da4__";